function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import { sans as zoram, fontSize18, lineHeightTight, fontWeightSemiBold } from "@churchofjesuschrist/eden-style-constants";
export const internalUseOnlyPriority4 = css(["margin:0;font-family:", ";font-weight:", ";font-size:", ";line-height:", ";"], zoram, fontWeightSemiBold, fontSize18, lineHeightTight);
const H4Styled = styled.h4.withConfig({
  componentId: "sc-12mz36o-0"
})(["", ";"], internalUseOnlyPriority4);

const H4 = _ref => {
  let {
    children,
    renderAs,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(H4Styled, _extends({
    as: renderAs
  }, props), children);
};

export default H4;
H4.propTypes = {
  /** Content inside heading */
  children: PropTypes.node.isRequired,

  /** The HTML tag string (e.g., `"div"`) or React component to render as. */
  renderAs: PropTypes.node
};